import { render } from "./adminLogin.vue?vue&type=template&id=a84c84d6"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__